<div class="overlay-fungame">
  <div id="dummy-overlay" (click)="onCloseClick(false)"></div>
  <div
    style="position: absolute; width: 100%"
    [ngStyle]="{ height: contentHeight + 'px' }"
  >
    <div id="dummy-overlay" (click)="onCloseClick(false)"></div>
    <table class="popup-container">
      <tr>
        <td>
          <div
            class="popup-img-sufficientfund"
            [ngClass]="[
              lobbyLoadingInsideViasino
                ? 'popup-img-sufficientfund-viasino'
                : ''
            ]"
          >
            <img
              class="img-bg"
              src="assets/images/common/pff_practice_alert_blank2_png@2x@2x.webp"
            />
            <div class="template-block-sufficientfund">
              <!--LINE 1-->
              <div
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_1 lang-specific-font-name"
              >
                <span>{{ 'LANG01066' | translate }}</span>
              </div>
              <!--LINE 2-->
              <div
                class="popup_pos_layout_playforfunpopup line_2 lang-specific-font-name"
              >
                <img
                  class="line_2_side_img"
                  [appImageSprite]="'house'"
                  [params]="common_icons"
                />
                <span class="line_2_balance">{{
                  userBalance | usercurrency | currencysymbol
                }}</span>
              </div>
              <!-- LINE 3a-->
              <div
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_3a lang-specific-font-name"
                (mouseover)="buttonOverOrOut(11)"
                (mouseout)="buttonOverOrOut(0)"
                (click)="buttonClick(11)"
              >
                <img
                  class="radio_circle"
                  [appImageSprite]="
                    activePlayType == 11 ? 'option_select' : 'option_unselect'
                  "
                  [params]="menu_icons"
                />
                <div class="table_type_incon_pos">
                  <img
                    class="line_3a_livecasino_icon"
                    [appImageSprite]="'livedealer'"
                    [params]="common_icons"
                  />
                </div>
                <span>{{ 'LANG00860' | translate }}</span>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>

              <!-- LINE 3b-->
              <div
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_3b lang-specific-font-name"
                (mouseover)="buttonOverOrOut(1)"
                (mouseout)="buttonOverOrOut(0)"
                (click)="buttonClick(1)"
              >
                <img
                  class="radio_circle"
                  [appImageSprite]="
                    activePlayType == 1 ? 'option_select' : 'option_unselect'
                  "
                  [params]="menu_icons"
                />
                <div class="table_type_incon_pos">
                  <img
                    class="line_3b_livecasino_icon"
                    [appImageSprite]="'livecasino'"
                    [params]="common_icons"
                  />
                </div>
                <span>{{ 'LANG00861' | translate }}</span>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>
              <!--LINE 4-->
              <div
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_4 lang-specific-font-name"
                (mouseover)="buttonOverOrOut(2)"
                (mouseout)="buttonOverOrOut(0)"
                (click)="buttonClick(2)"
              >
                <img
                  class="radio_circle"
                  [appImageSprite]="
                    activePlayType == 2 ? 'option_select' : 'option_unselect'
                  "
                  [params]="menu_icons"
                />
                <div class="table_type_incon_pos">
                  <img
                    class="line_4_private_icon"
                    [appImageSprite]="'private'"
                    [params]="common_icons"
                  />
                </div>
                <span>{{ 'LANG00862' | translate }}</span>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>
              <!--LINE 5-->
              <div
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_5 lang-specific-font-name"
              >
                <span>{{ 'LANG01074' | translate }}</span>
              </div>
              <!--line 6-->
              <div
                class="popup_pos_layout_playforfunpopup line_6 lang-specific-font-name"
              >
                <img
                  class="line_6_side_img"
                  [appImageSprite]="'bet_icon'"
                  [params]="common_icons"
                />
                <span class="line_6_balance">{{
                  funUserBalance | usercurrency | currencysymbol
                }}</span>
              </div>
              <!--line 7-->
              <div
                *ngIf="!inSufficientFund"
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_7 lang-specific-font-name"
                (mouseover)="buttonOverOrOut(3)"
                (mouseout)="buttonOverOrOut(0)"
                (click)="buttonClick(3)"
              >
                <img
                  class="radio_circle"
                  [appImageSprite]="
                    activePlayType == 3 ? 'option_select' : 'option_unselect'
                  "
                  [params]="menu_icons"
                />
                <div class="table_type_incon_pos">
                  <img
                    class="line_4_private_icon"
                    [appImageSprite]="'private'"
                    [params]="common_icons"
                  />
                </div>
                <span>{{ 'LANG00862' | translate }}</span>
                <div class="arrow_icon_top">
                  <img
                    class="arrow_icon"
                    [appImageSprite]="'arrow_icon'"
                    [params]="common_icons"
                  />
                </div>
              </div>
              <div
                *ngIf="inSufficientFund"
                class="popup_pos_layout_playforfunpopup playforfunpopup_lang_specific line_7 lang-specific-font-name"
              >
                <!--(mouseover)="buttonOverOrOut(3)" (mouseout)="buttonOverOrOut(0)" (click)="buttonClick(3)"-->
                <div class="table_type_incon_pos">
                  <img
                    class="line_7_side_img"
                    [appImageSprite]="'pff_white_alert_icon@2x'"
                    [params]="menu_icons"
                  />
                </div>
                <span>{{ 'LANG01072' | translate }}</span>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>
</div>
